<template>
  <div>

    <!--Banner Parallax-->
    <section class="topBanner" ref="parallaxBanner" :style="{ backgroundPositionY: parallaxOffset + 'px' }">
      <div class="bannerOverlay">
        <h1 class="bannerTitle">Nos services</h1>
      </div>
    </section>

    <!--Urgence 24h-->
    <section id="emergency" class="v-primary-light-1 sectionPad gridpad">
      <v-row>
        <v-col cols="12">
          <div class="padPump txt-c">
            <h2 class="pumpSectionTitle">{{ $t('emergency.title') }}</h2>
            <p class="mt-5" v-html="$t('emergency.txt')"></p>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--ContactUs-->
    <contactUs/>

    <!--Entretien et réparation pompe-->
    <section id="repairPump" class="sectionPad">
      <v-row class="gridpad">
        <v-col cols="12">
          <h2 class="pumpSectionTitle txt-c">{{ $t('pumpRepair.title') }}</h2>
        </v-col>
        <v-col cols="12" class="mt-6">
          <h3 class="pumpSectionSubtitle txt-c">{{ $t('pumpRepair.subtitle') }}</h3>
          <p class="txt-j mt-5" v-html="$t('pumpRepair.text')"></p>
          <p class="txt-c mt-5">{{ $t('pumpRepair.link') }}</p>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col cols="12" md="6" class="pa-0">
          <div class="fullImg imgReparePump1" @click="openLightbox('/Resources/images/Services/moteurPompe.jpg')">
            <div class="fullImgOverlay"><span class="zoomIcon" v-html="zoomSvg"></span></div>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="pa-0">
          <div class="fullImg imgReparePump2" @click="openLightbox('/Resources/images/Services/MoteurPompeNeuf.jpg')">
            <div class="fullImgOverlay"><span class="zoomIcon" v-html="zoomSvg"></span></div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Réparation moteur-->
    <section id="repairEngine" class="sectionPad gridpad">
      <v-row>
        <v-col cols="12">
          <h2 class="pumpSectionTitle txt-c">{{ $t('repareMotor.title') }}</h2>
          <p class="txt-c mt-5" v-html="$t('repareMotor.text')"></p>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center mt-6">
        <v-col cols="12" md="6" class="pa-0">
          <div class="fullImg imgmotor1" @click="openLightbox('/Resources/images/Services/electricMotorRepair1.jpg')">
            <div class="fullImgOverlay"><span class="zoomIcon" v-html="zoomSvg"></span></div>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="pa-0">
          <div class="fullImg imgmotor2" @click="openLightbox('/Resources/images/Services/MoteurY559.jpg')">
            <div class="fullImgOverlay"><span class="zoomIcon" v-html="zoomSvg"></span></div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Forage-->
    <section id="artesianWell" class="bgForage">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Services/summersiblePump.jpg')">
            <div class="imgForage photoImg">
              <div class="photoHoverOverlay">
                <span class="zoomIcon" v-html="zoomSvg"></span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="txt-j d-flex align-center">
          <div class="padForage">
            <h2 class="pumpSectionTitle">{{ $t('forage.title') }}</h2>
            <p class="mt-5" v-html="$t('forage.text')"></p>
            <h3 class="slogan mt-10">{{ $t('forage.slogan') }}</h3>
            <ol class="olPad">
              <li v-html="$t('forage.text2')"></li>
              <li v-html="$t('forage.text3')"></li>
            </ol>
          </div>
        </v-col>
      </v-row>
    </section>
    <!--Section Forage-->
    <section class="forageSection">
      <v-row class="d-flex align-stretch ma-0">
        <v-col cols="12" lg="6" class="forageLeft pa-0">
          <div class="forageTextWrap">
            <h2 class="forageTitle">Forage de puits, pompe et traitement d'eau : <span class="forageTitleAccent">une seule compagnie Bisson Service</span></h2>
            <p class="forageText">Chez Bisson Service, nous offrons un service tout inclus pour répondre à vos besoins en eau. Du forage de votre puits à l'installation complète du système de pompage et de traitement de l'eau, nous prenons tout en charge pour vous offrir une solution clé en main. Faites confiance à notre expertise pour une eau de qualité, directement chez vous!</p>
            <div class="forageServicesLabel">Nos services</div>
            <div class="forageServicesGrid">
              <div class="forageServiceItem" v-for="(item, i) in forageServices" :key="i">
                <span class="forageCheck">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span class="forageServiceText">{{ item }}</span>
              </div>
            </div>
            <div class="foragePhotosRow">
              <div class="forageThumb" v-for="(p, i) in foragePhotos" :key="i" :style="{ backgroundImage: 'url(' + p + ')' }"></div>
            </div>
            <router-link class="forageBtn" to="/forage">En savoir plus →</router-link>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="pa-0 forageRight">
          <div class="forageImgWrap">
            <div class="forageImg" :style="{ backgroundImage: 'url(/Resources/images/Forage/forageBanner.jpg)' }"></div>
          </div>
        </v-col>
      </v-row>
      <!-- Bande bleue avec profondeur 3D -->
      <svg class="forageBandSvg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 800" preserveAspectRatio="none">
        <defs>
          <linearGradient id="bandDepth" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%"   stop-color="rgb(8,45,110)"/>
            <stop offset="25%"  stop-color="rgb(15,82,163)"/>
            <stop offset="50%"  stop-color="rgb(30,120,220)"/>
            <stop offset="75%"  stop-color="rgb(15,82,163)"/>
            <stop offset="100%" stop-color="rgb(8,45,110)"/>
          </linearGradient>
          <linearGradient id="bandShine" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%"   stop-color="rgba(255,255,255,0)"/>
            <stop offset="40%"  stop-color="rgba(255,255,255,0)"/>
            <stop offset="55%"  stop-color="rgba(255,255,255,0.25)"/>
            <stop offset="65%"  stop-color="rgba(255,255,255,0.10)"/>
            <stop offset="100%" stop-color="rgba(255,255,255,0)"/>
          </linearGradient>
        </defs>
        <path d="M0,0 L22,0 C45,200 5,400 28,600 C38,700 35,760 22,800 L0,800 Z" fill="#f5f7fa"/>
        <path d="M22,0 C45,200 5,400 28,600 C38,700 35,760 22,800 L40,800 C45,760 48,700 42,600 C20,400 55,200 40,0 Z" fill="url(#bandDepth)"/>
        <path d="M22,0 C45,200 5,400 28,600 C38,700 35,760 22,800 L40,800 C45,760 48,700 42,600 C20,400 55,200 40,0 Z" fill="url(#bandShine)"/>
      </svg>
    </section>

    <!--Contrôleur à pression-->
    <section id="pressureController" class="sectionPad gridpad">
      <v-row class="d-flex flex-wrap-reverse justify-center">
        <v-col cols="12" lg="6">
          <div class="padPump">
            <h2 class="pumpSectionTitle">{{ $t('controller.title') }}</h2>
            <p class="mt-5" v-html="$t('controller.txt1')"></p>
            <p v-html="$t('controller.txt2')"></p>
            <router-link class="button mt-4" to="/contact"><p class="buttonText" v-html="$t('controller.btn')"></p></router-link>
          </div>
        </v-col>
        <v-col cols="12" lg="6">
          <v-row>
            <v-col cols="12" class="pa-0 d-flex justify-center">
              <div class="photoCard" @click="openLightbox('/Resources/images/Products/AquavarSolo-images.jpg')">
                <div class="controllerImg1 photoImg">
                  <div class="photoHoverOverlay">
                    <span class="zoomIcon" v-html="zoomSvg"></span>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" class="pa-0 d-flex justify-center mt-4">
              <div class="photoCard" @click="openLightbox('/Resources/images/Products/AquavarSolo-GoudspumpsV2.jpg')">
                <div class="controllerImg2 photoImg">
                  <div class="photoHoverOverlay">
                    <span class="zoomIcon" v-html="zoomSvg"></span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </section>

    <!--Lightbox Popup-->
    <transition name="lightbox-fade">
      <div v-if="lightboxOpen" class="lightboxBackdrop" @click.self="closeLightbox">
        <div class="lightboxContainer">
          <button class="lightboxClose" @click="closeLightbox">&times;</button>
          <img class="lightboxImg" :src="lightboxSrc" alt="Photo service"/>
        </div>
      </div>
    </transition>

  </div>
</template>

<style scoped>
  p { font-size: 18px; color: rgba(var(--menuColor), 0.6); }
  .sectionPad { padding: 50px 0px; }
  .gridpad { padding-bottom: 50px; }
  .padPump { text-align: justify; padding: 15px 50px; }
  .olPad { padding: 0px 40px; }
  ol li { padding: 20px 0px; font-size: 18px; color: rgba(var(--menuColor), 0.6); }

  /*#region Banner Parallax*/
  .topBanner {
    height: 600px;
    background-image: url('../../public/Resources/images/Banner/bannerArtesian.jpg');
    background-attachment: fixed;
    background-position: center 30%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    will-change: background-position-y;
  }
  .bannerOverlay {
    background-color: rgba(0, 0, 0, 0.45);
    padding: 40px 70px;
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 700px;
  }
  .bannerTitle {
    color: #ffffff;
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin: 0;
  }
  /*#endregion*/

  /*#region Unified Titles*/
  .pumpSectionTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 26px; }
  .pumpSectionSubtitle { color: rgba(var(--menuColor), 0.8); font-weight: 600; font-size: 20px; }
  .slogan { color: rgba(var(--menuColor), 0.7); font-weight: 500; font-size: 20px; }
  /*#endregion*/

  /*#region Full-bleed clickable images (motor, pump repair)*/
  .fullImg {
    height: 550px;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    cursor: pointer;
    transition: filter 0.3s ease;
  }
  .fullImg:hover { filter: brightness(0.80); }
  .fullImgOverlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0,0,0,0);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
  }
  .fullImg:hover .fullImgOverlay { background-color: rgba(0,0,0,0.25); }
  .fullImg:hover .zoomIcon { opacity: 1; }
  .imgReparePump1 { background-image: url("../../public/Resources/images/Services/moteurPompe.jpg"); }
  .imgReparePump2 { background-image: url("../../public/Resources/images/Services/MoteurPompeNeuf.jpg"); }
  .imgmotor1     { background-image: url("../../public/Resources/images/Services/electricMotorRepair1.jpg"); }
  .imgmotor2     { background-image: url("../../public/Resources/images/Services/MoteurY559.jpg"); }
  /*#endregion*/

  /*#region Photo Cards*/
  .photoCard {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0,0,0,0.18);
    cursor: pointer;
    width: 100%;
    max-width: 520px;
    margin: 20px auto;
  }
  .photoImg {
    height: 420px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #ffffff;
    transition: transform 0.4s ease;
    position: relative;
  }
  .photoCard:hover .photoImg { transform: scale(1.03); }
  .photoHoverOverlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0,0,0,0);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
  }
  .photoCard:hover .photoHoverOverlay { background-color: rgba(0,0,0,0.30); }
  .imgForage      { background-image: url("../../public/Resources/images/Services/summersiblePump.jpg"); }
  .controllerImg1 { background-image: url("../../public/Resources/images/Products/AquavarSolo-images.jpg"); background-size: cover; height: 300px; }
  .controllerImg2 { background-image: url("../../public/Resources/images/Products/AquavarSolo-GoudspumpsV2.jpg"); background-size: cover; }
  /*#endregion*/

  /*#region Zoom Icon*/
  .zoomIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    filter: drop-shadow(0 2px 6px rgba(0,0,0,0.6));
  }
  .photoCard:hover .zoomIcon { opacity: 1; }
  /*#endregion*/

  /*#region Forage*/
  .bgForage { background-color: rgb(var(--tierce2)); padding: 50px 0px; }
  .padForage { padding: 15px 150px 0px 45px; }
  /*#endregion*/

  /*#region Lightbox*/
  .lightboxBackdrop {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.88);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lightboxContainer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000;
  }
  .lightboxImg {
    max-width: 88vw;
    max-height: 88vh;
    border-radius: 6px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.6);
    object-fit: contain;
    display: block;
  }
  .lightboxClose {
    position: fixed;
    top: 20px;
    right: 28px;
    font-size: 44px;
    color: #ffffff;
    background: none;
    border: none;
    cursor: pointer;
    line-height: 1;
    opacity: 0.85;
    transition: opacity 0.2s;
    z-index: 100001;
  }
  .lightboxClose:hover { opacity: 1; }
  .lightbox-fade-enter-active, .lightbox-fade-leave-active { transition: opacity 0.25s ease; }
  .lightbox-fade-enter-from, .lightbox-fade-leave-to { opacity: 0; }
  /*#endregion*/

  @media handheld, only screen and (max-width: 600px) {
    .topBanner { height: 400px; background-attachment: scroll; }
    .bannerTitle { font-size: 22px; }
    .bannerOverlay { padding: 25px 20px; }
    .padPump { padding: 15px; }
    .fullImg { height: 280px; }
    .photoImg { height: 280px; }
    .padForage { padding: 15px; }
    .forageBandSvg { display: none; }
    .forageTextWrap { padding: 30px 20px; }
    .forageServicesGrid { grid-template-columns: 1fr; }
    .forageThumb { height: 70px; }
    .forageRight { min-height: 280px; }
    .forageImgWrap { min-height: 280px; }
  }
  @media handheld, only screen and (max-width: 960px) {
    .topBanner { height: 500px; background-attachment: scroll; }
    .sectionPad { padding: 30px 0px; }
    .gridpad { padding: 0px 25px 50px 25px; }
    .padPump { padding: 15px 20px; }
    .fullImg { height: 350px; }
    .padForage { padding: 15px; }
    .forageBandSvg { display: none; }
    .forageTextWrap { padding: 30px 25px; }
    .forageRight { min-height: 280px; }
    .forageImgWrap { min-height: 280px; }
    .forageServicesGrid { grid-template-columns: 1fr; }
    .forageThumb { height: 70px; }
  }
  /*#region Section Forage*/
  .forageSection { background-color: #f5f7fa; overflow: hidden; position: relative; }
  .forageLeft { background-color: #f5f7fa; }
  .forageTextWrap { padding: 55px 60px 45px 70px; }
  .forageTitle { color: rgb(var(--secondary)); font-size: 24px; font-weight: 800; line-height: 1.25; text-transform: uppercase; margin-bottom: 16px; }
  .forageTitleAccent { color: rgb(var(--secondary)); }
  .forageText { color: rgba(var(--menuColor), 0.65); font-size: 15px !important; line-height: 1.7; margin-bottom: 22px; text-align: justify; }
  .forageServicesLabel { display: inline-block; background-color: rgb(var(--secondary)); color: #ffffff; font-size: 13px; font-weight: 700; padding: 7px 20px; border-radius: 3px; margin-bottom: 18px; }
  .forageServicesGrid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px 20px; margin-bottom: 28px; }
  .forageServiceItem { display: flex; align-items: center; gap: 10px; }
  .forageCheck { width: 22px; height: 22px; flex-shrink: 0; background-color: rgb(var(--primary)); border-radius: 50%; display: flex; align-items: center; justify-content: center; }
  .forageServiceText { font-size: 15px; color: rgba(var(--menuColor), 0.75); font-weight: 500; }
  .foragePhotosRow { display: flex; gap: 12px; margin-bottom: 28px; }
  .forageThumb { flex: 1; height: 90px; border-radius: 12px; background-position: center; background-repeat: no-repeat; background-size: cover; box-shadow: 0 3px 10px rgba(0,0,0,0.15); }
  .forageBtn { display: inline-block; background-color: rgb(var(--primary)); color: #ffffff; padding: 12px 30px; border-radius: 4px; font-weight: 700; font-size: 14px; text-decoration: none; text-transform: uppercase; letter-spacing: 1px; transition: background-color 0.25s, transform 0.25s; }
  .forageBtn:hover { background-color: rgb(var(--secondary)); transform: translateY(-2px); }
  .forageRight { position: relative; min-height: 500px; }
  .forageImgWrap { position: relative; height: 100%; min-height: 500px; }
  .forageImg { position: absolute; inset: 0; background-position: center; background-repeat: no-repeat; background-size: cover; }
  .forageBandSvg { position: absolute; left: calc(50% - 40px); top: 0; height: 100%; width: 80px; z-index: 10; pointer-events: none; }
  /*#endregion*/
  @media handheld, only screen and (max-width: 1378px) {
    .padForage { padding: 15px; }
  }
  @media handheld, only screen and (max-width: 1594px) {
    .padForage { padding: 45px 15px 0px 15px; }
  }
</style>

<script>
  import pageTranslations from '../../public/Resources/i18N/services.json';
  import servicesSection from '../components/services.vue';
  import contactUs from '@/components/bannerContactUs.vue';

  export default {
    name: 'ServicesPage',
    data: () => ({
      parallaxOffset: 0,
      lightboxOpen: false,
      lightboxSrc: '',
      pageTitle: 'Nos Services',
      zoomSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="22" y2="22"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>',
      forageServices: [
        'Forage de puits',
        'Installation traitement d\'eau',
        'Installation de pompe',
        'Service clé en main',
      ],
      foragePhotos: [
        '/Resources/images/Forage/forage-1.jpg',
        '/Resources/images/Forage/forage-2.jpg',
        '/Resources/images/Forage/forage-3.jpg',
      ],
    }),
    methods: {
      handleParallax() {
        if (!this.$refs.parallaxBanner) return;
        this.parallaxOffset = Math.round(window.scrollY * 0.4);
      },
      openLightbox(src) {
        this.lightboxSrc = src;
        this.lightboxOpen = true;
        document.body.style.overflow = 'hidden';
      },
      closeLightbox() {
        this.lightboxOpen = false;
        document.body.style.overflow = '';
      },
      handleKeydown(e) {
        if (!this.lightboxOpen) return;
        if (e.key === 'Escape') this.closeLightbox();
      },
    },
    mounted() {
      this.$i18n.mergeLocaleMessage('fr', pageTranslations.fr);
      this.$i18n.mergeLocaleMessage('en', pageTranslations.en);
      window.addEventListener('scroll', this.handleParallax);
      window.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleParallax);
      window.removeEventListener('keydown', this.handleKeydown);
    },
    components: {
      contactUs,
      'services-section': servicesSection,
    },
  }
</script>